import React from 'react'
import type { PortalProps as MuiPortalProps } from '@material-ui/core/Portal'
import MuiPortal from '@material-ui/core/Portal'

export type PortalProps = MuiPortalProps

function Portal(props: PortalProps) {
  return <MuiPortal {...props} />
}

export default Portal
